import { FunctionComponent } from "react";
import {
  CalendarIcon,
  IIconsBaseProps,
  OrdersIcon,
  UserIcon,
} from "../components/Primitives/Icons";
import { isCustomer, isPomAgency, isPomAgencyMember, isPomRepresentative, IUser, } from "../domain/user/user";
import { AvailablePomRoutes, AvailableBaseRoutes, } from "./constants";

export interface IShortcut {
  name: ShortcutType;
  display: boolean;
  mandatoryPomMainContact: boolean;
  translation: string;
  route: string;
  icon: FunctionComponent<IIconsBaseProps>;
}

export enum ShortcutType {
  Reporting = "Reporting",
  GroupOverview = "GroupOverview",
  ManufacturerOverview = "ManufacturerOverview",
}

// #region Shortcuts
export const getPomShortcuts = (user: IUser | undefined): IShortcut[] => {
  const displayReporting =
    isCustomer(user) ||
    isPomRepresentative(user) ||
    isPomAgencyMember(user) ||
    (isPomAgency(user) && user?.group?.isPomAgencyAnnouncer === true);

  return [
    {
      name: ShortcutType.Reporting,
      display: displayReporting,
      mandatoryPomMainContact: false,
      translation: "dashboard.platform.shortcuts.pom.new_reporting",
      route: AvailablePomRoutes.Reporting,
      icon: CalendarIcon,
    },
    {
      name: ShortcutType.GroupOverview,
      display: isCustomer(user) || isPomAgency(user) || isPomRepresentative(user),
      mandatoryPomMainContact: true,
      translation: "dashboard.platform.shortcuts.pom.group_overview",
      route: AvailableBaseRoutes.GroupDetail,
      icon: OrdersIcon,
    },
    {
      name: ShortcutType.ManufacturerOverview,
      display: isPomAgency(user),
      mandatoryPomMainContact: false,
      translation: "dashboard.platform.shortcuts.pom.manufactorer_overview",
      route: AvailablePomRoutes.Agency,
      icon: UserIcon,
    },
  ];
};
// #endregion
